import React from 'react';
import './CustomerSegments.css';

const CustomerSegments: React.FC = () => {
  return (
    <section className="customer-segments">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Core Solutions</div>
          <h2 className="section-title">Powering Critical Financial Decisions</h2>
          <p className="section-subtitle">Our graph intelligence platform delivers fast, accurate credit assessments for your most important use cases.</p>
        </div>
        
        <div className="segments-grid">
          <div className="segment-card">
            <div className="segment-header">
              <div className="segment-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                  <path d="M21 14L22 17L25 18L22 19L21 22L20 19L17 18L20 17L21 14Z" fill="currentColor"/>
                  <path d="M3.5 14L4.5 17L7.5 18L4.5 19L3.5 22L2.5 19L-0.5 18L2.5 17L3.5 14Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Credit Assessments</h3>
            </div>
            <p>Enhanced decisioning for loans and high-value transactions using graph-based insights. Uncover hidden relationships between entities to make more accurate lending decisions for larger-ticket purchases and complex financial products.</p>
            <div className="segment-footer">
              <span className="segment-detail">High-Value Loans</span>
              <span className="segment-detail">Risk Intelligence</span>
            </div>
          </div>
          
          <div className="segment-card">
            <div className="segment-header">
              <div className="segment-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 4V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V4H20C20.5523 4 21 4.44772 21 5V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V5C3 4.44772 3.44772 4 4 4H7ZM9 3V4H15V3H9ZM5 6V17H19V6H5Z" stroke="currentColor" stroke-width="2"/>
                  <path d="M3 8H21" stroke="currentColor" stroke-width="2"/>
                  <path d="M15 12L17 14L15 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 12H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <h3>B2B E-commerce</h3>
            </div>
            <p>Lightning-fast credit assessments for B2B e-commerce purchases. Enable real-time approval decisions with sub-second response times while maintaining accuracy through comprehensive relationship analysis and fraud detection.</p>
            <div className="segment-footer">
              <span className="segment-detail">Real-time Decisions</span>
              <span className="segment-detail">Fast API Response</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerSegments;